import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    auth: {
        username: process.env.REACT_APP_API_USERNAME,
        password: process.env.REACT_APP_API_PASSWORD
    }
});

export default api;